<div class="sidenav" [ngClass]="isExpanded ? 'sidenav-collapsed' : ''">
    <div class="logo-container">
        <button class="logo" (click)="toggleCollapse()">
            <img *ngIf="isExpanded" src="./../../assets/inchcape logo.png" class="brand-logo" />
            <img *ngIf="!isExpanded" src="./../../assets/Inchcape sub Logo.svg" class="brand-sub-logo" />
        </button>
        <button class="btn-nav-collapse" *ngIf="isExpanded" (click)="toggleCollapse()">
        </button>
    </div>
   
    <ul class="sidenav-nav">
        <div *ngIf="isExpanded && helperService.user.userMix === 1" class="checkbox-container">
            <mat-checkbox class="custom-checkbox"  labelPosition="before"  [checked]="helperService.checkbokMix === 0" (change)="onCheckboxChange(0)" >DBS</mat-checkbox>
            <mat-checkbox class="custom-checkbox" labelPosition="before"   [checked]="helperService.checkbokMix !== 0" (change)="onCheckboxChange(1)" >Incadea</mat-checkbox>
        </div>
    
        <div class="menu-container" *ngFor="let menu of navbarMenus">
            <li *ngIf="!menu.subMenus" class="sidenav-nav-item">
                <a class="sidenav-nav-link sidenav-nav-link-border no-sub-menus" [routerLink]="[menu.routeLink]" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}"(click)="menuP(menu.label,menu.icon)">
                    <i class="material-icons-outlined" >{{menu.icon}}</i>
                    <span class="sidenav-link-text" *ngIf="isExpanded">{{menu.label | translate }}</span>
                </a>
            </li>
            <li *ngIf="menu.subMenus && !isExpanded" class="sidenav-nav-item">
                <a class="sidenav-nav-link sidenav-nav-link-border no-sub-menus" [ngClass]="isMenuExapanded(menu.subMenus) ? 'active' : ''"
                    [mat-menu-trigger-for]="subMenuCollapsed">
                    <i class="material-icons-outlined" >{{menu.icon}}</i>
                    <span class="sidenav-link-text" *ngIf="isExpanded">{{menu.label | translate }}</span>
                </a>
                <mat-menu #subMenuCollapsed="matMenu">
                    <a mat-menu-item *ngFor="let subMenu of menu.subMenus" class="sidenav-nav-link sidenav-nav-link-borderno-sub-menus"
                        [routerLink]="[subMenu.routeLink]"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{exact: true}">
                        <span class="sidenav-link-text">{{subMenu.label | translate }}</span>
                    </a>
                </mat-menu>
            </li>
            <mat-accordion *ngIf="menu.subMenus && isExpanded">
                <mat-expansion-panel [expanded]="isMenuExapanded(menu.subMenus)">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <li class="sidenav-nav-item sidenav-nav-link-border">
                                <a class="sidenav-nav-link">
                                    <i class="material-icons-outlined" >{{menu.icon}}</i>
                                    <span class="sidenav-link-text" *ngIf="isExpanded">{{menu.label | translate }}</span>
                                </a>
                            </li>
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div *ngFor="let subMenu of menu.subMenus">
                        <li class="sidenav-nav-item sidenav-nav-link-border">
                            <a class="sidenav-nav-link no-sub-menus" [routerLink]="[subMenu.routeLink]"
                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)=" SubMenu(menu.label,subMenu.label,menu.icon)">
                                <span class="sidenav-link-text" *ngIf="isExpanded">{{subMenu.label | translate }}</span>
                            </a>
                        </li>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
        <li class="sidenav-nav-item btn-logout">
            <a (click)="onClickCloseSession()" class="sidenav-nav-link no-sub-menus" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="sidenav-link-icon bi bi-box-arrow-right"></i>
                <span class="sidenav-link-text" *ngIf="isExpanded">  {{ 'Logout' | translate }} </span>
            </a>
        </li>
    </ul>
</div>
